import React from 'react';
import Table from '../common/Table';
import tableConfig, { data } from './config';
import { GET_CATEGORIES_ALL } from '../../constants';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '../common/Input';
import Button from '../common/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import FormValidator from '../../utils/validator';
import { toast } from 'react-toastify';
import { updatecategory, deletecategory, createCategory } from '../../actions/category';
import { useState } from 'react';
import { Image, Switch, Upload } from 'antd';
import { Add } from "@material-ui/icons";
import { beforeUpload, getBase64FromImage } from '../../utils/common.utils';


const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

const Categories = props => {
  const [isLoading, setLoading] = useState(false);
  const classes = props.classes;

  let session = sessionStorage.getItem('user'),
    countryid = session ? `${JSON.parse(session).findAdmin.country_id}` : '',
    config = tableConfig(props);
  const [categories, setCategories] = useState([]);

  let initialState = {
    open: false,
    errors: null,
  
    tableKey: 1,
    category: {}
  }

  const [state, setState] = useState(initialState);

  const handleClose = () => {
    setState((prev) => ({
      ...prev,
      open: false
    }))
  };

  const onDelete = rowdata => {
    setLoading(true);
    deletecategory(rowdata.category_id, (message, isError) => {
      const method = isError ? 'error' : 'success';
      toast[method](message);
      setLoading(false);
      if (method === 'success') {
        setState((prev) => ({
          ...prev,
          tableKey: (state.tableKey + 1)
        }))
        // setState.tableKey(state.tableKey + 1);
        //window.location.reload();
      }
    });
  };

  const onEdit = rowdata => {
    setState((prev) => ({
      ...prev,
      category_id: rowdata.category_id,
      category_name: rowdata.category_name,
      category_status: rowdata.status,
      category_image: {
        base64url: null,
        file: null,
        url: rowdata.image_url
      },
      category: { 
        status: rowdata.status 
      },
      open: true
    }))
  };

  const schema = [
    {
      field: 'category_name',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Category is required.'
    }
  ];
  const validator = new FormValidator(schema);

  const handleChange = (key, e) => {
    setState((prev) => ({
      ...prev,
      category: {
        ...prev.category,
        category_id: state.category_id,
        [key]: e.target.value,
        category_status: state.category_status
      },
      [key]: e.target.value,
    }))

    // setState.category({
    //   categoryId: state.cateid,
    //   [key]: e.target.value,
    //   categoryStatus: state.catestatus
    // });
  };

  const updateCategory = () => {
    // const err = validator.validate({ ...state.category });
    // setState((prev) => ({
    //   ...prev,
    //   errors: err
    // }));

    // if (!err.isValid) {
    //   return;
    // }
    console.log({ stateCategory: state.category });
    setState((prev) => ({
      ...prev,
      isLoading: true,
    }));

    updatecategory(state.category_id, state.category, (message, isError) => {
      const method = isError ? 'error' : 'success';
      toast[method](message);

      setState((prev) => ({
        ...prev,
        isLoading: false,
      }));

      if (!isError) {
        handleClose();
        setState((prev) => ({
          ...prev,
          tableKey: (state.tableKey + 1)
        }));
        // setState.tableKey(state.tableKey + 1);
      }
    });
    handleClose();
  };

  const addCategory = () => {
    console.log({ stateCategory: state.category });
    setState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    if(state.category && state.category.category_name && state.category.image){
      createCategory(state.category, (message, isError) => {
        const method = isError ? 'error' : 'success';
        toast[method](message);
  
        setState((prev) => ({
          ...prev,
          isLoading: false,
        }));
  
        if (!isError) {
          handleClose();
          setState((prev) => ({
            ...prev,
            tableKey: (state.tableKey + 1)
          }));
          // setState.tableKey(state.tableKey + 1);
        }
      });
      handleClose();
    }
  };


  const handleUploadImage = async (event) => {
    try {
      const file = event.file;
      // const isValidImage = beforeUpload(file.originFileObj)
      // if (!isValidImage) {
      //   return;
      // }

      const imageData = {
        base64url: await getBase64FromImage(file.originFileObj),
        file: file.originFileObj,
        // url: null
      }

      setState(prev => ({
        ...prev,
        category: {
          ...prev.category,
          image: imageData.base64url
        },
        category_image: {
          ...prev.category_image,
          base64url: imageData.base64url
        }
      }))
      //  setErrorMessages({ ...errors, banner_image: "" })
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <div>

      <Button label={'Add Category'} onClick={() => {
        initialState = {
          ...initialState,
          category: {
            status: false
          },
          open: true
        };
        setState(initialState)
      }} color="primary" styles={{ marginBottom: "10px" }} />

      <Table
        key={state.tableKey}
        tableConfig={config}
        data={data}
        // onDelete={onDelete}
        onEdit={onEdit}
        apidata="categories"
        countryid={countryid}
        url={`${GET_CATEGORIES_ALL}`}
      />
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={state.open}
        onBackdropClick="false"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Update Category
        </DialogTitle>
        <DialogContent dividers>
          <Card className={classes.root}>
            <CardContent>
              <TextField
                label="Category Name"
                name="category_name"
                placeholder="Update Category name"
                onChange={e => handleChange('category_name', e)}
                classes={{ root: classes.input }}
                value={state.category_name}
                error={
                  state.errors &&
                  state.errors.category_name &&
                  state.errors.category_name.isInvalid
                }
                helperText={
                  state.errors &&
                  state.errors.category_name &&
                  state.errors.category_name.isInvalid &&
                  state.errors.category_name.message
                }
              />

              <div className='mb-3 flex'>
                <div>
                  <div>Category Image : </div>
                  <div className="banner-upload-wraper">
                    <Upload
                      name="banner_image"
                      listType="picture-card"
                      className="avatar-uploader"
                      showUploadList={false}
                      beforeUpload={beforeUpload}
                      onChange={handleUploadImage}
                    >
                      {(state.category_image?.base64url || state.category_image?.url)
                        ?
                        <>
                          <Image
                            className="banner-image"
                            preview={false}
                            src={state.category_image?.base64url || state.category_image?.url}
                            alt="banner-image"
                            style={{ width: '100%' }} />
                        </>

                        : <>
                          <div>
                            <Add />
                            <div style={{ marginTop: 8 }}>Upload</div>
                          </div>
                        </>
                      }
                    </Upload>
                  </div>
                </div>
              </div>

              <div className="flex mb-3">
                <Switch
                  checked={state.category_status === "true" || state.category_status === true || false}
                  onChange={(isChecked) => {
                    setState((prev) => ({
                      ...prev,
                      category_status: isChecked ? "true" : "false",
                      category: { ...prev.category, status: isChecked ? "true" : "false" }
                    }))
                  }}
                />
                <div className="mx-2">Do you want to make this category active?</div>
              </div>

            </CardContent>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button autoFocus size="small" label={`${state?.category_id ? 'Save' : 'Add'}`} 
            onClick={() => 
              state?.category_id ? updateCategory() : addCategory()
            }>
            Save changes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Categories;
